import React from 'react';

const PostalKPIs = ({ postalStats, isDark }) => {
  if (!postalStats) return null;

  const stats = [
    {
      label: 'Postal Sent',
      value: postalStats.totalPostalSent || 0,
      icon: '/assets/icons/mail-check.svg',
      color: '#00A86B'
    },
    {
      label: 'Postal Failed',
      value: postalStats.totalPostalFailed || 0,
      icon: '/assets/icons/mail-x.svg',
      color: '#B42318'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-[16px] sm:gap-[20px] w-full">
      {stats.map((stat, index) => (
        <div
          key={index}
          className={`border-solid border-[1px] rounded-[16px] sm:rounded-[24px] p-[16px] sm:p-[20px] flex items-center justify-between transition-colors duration-200 ${
            isDark ? 'bg-[#161515] border-[#292929]' : 'bg-white border-[#d9d9d9]'
          }`}
        >
          <div className="flex flex-col items-start gap-[8px]">
            <div
              className="w-[24px] h-[24px]"
              style={{
                backgroundColor: stat.color,
                WebkitMaskImage: `url('${stat.icon}')`,
                WebkitMaskRepeat: 'no-repeat',
                WebkitMaskSize: 'contain',
                WebkitMaskPosition: 'center',
                maskImage: `url('${stat.icon}')`,
                maskRepeat: 'no-repeat',
                maskSize: 'contain',
                maskPosition: 'center',
              }}
              aria-hidden="true"
            />
            <span className={`text-[14px] sm:text-[16px] font-medium transition-colors duration-200 ${
              isDark ? 'text-[#b3b3b3]' : 'text-[#686868]'
            }`}>
              {stat.label}
            </span>
          </div>
          <div
            className="text-[20px] sm:text-[20px] font-bold transition-colors duration-200"
            style={{ color: stat.color }}
          >
            {stat.value}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PostalKPIs;
